/**
 * Composition pour initialiser la liste des timezones
 */

import { ref, computed } from 'vue';
/***/
import { useTimeZoneStore } from '@stores/timeZone';

export function useTimeZone({}) {

    const timeZoneStore = useTimeZoneStore();

    const loadingTimeZones = ref(false);
    const loadTimeZonesError = ref(false);

    // Liste des timezones
    const timeZones = computed(() => timeZoneStore.getTimeZones);

    // Chargement de la liste des timezones
    const loadTimeZones = (() => {
        if(loadingTimeZones.value) {
            return Promise.reject();
        }

        loadingTimeZones.value = true;
        loadTimeZonesError.value = false;

        return timeZoneStore.loadTimeZoneList().then(() => {
            return Promise.resolve();
        }).catch((e) => {
            loadTimeZonesError.value = true;
            return Promise.reject();
        }).finally(() => {
            loadingTimeZones.value = false;
        });
    });

    return {
        loadingTimeZones,
        loadTimeZonesError,
        loadTimeZones,
        timeZones
    }

};
